var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('wizard-renderer',{ref:"editor",attrs:{"definition":_vm.createDefinition()},on:{"done":_vm.handleDone}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }